import { Select } from 'components/Form'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { setCompany, setCustomer, setCompaniesDict } from 'store/filterdata/filterDataSlice'
import { useEffect } from 'react'
// import DropdownMessage from './DropdownMessage'
// import DropdownNotification from './DropdownNotification'
// import DropdownUser from "./DropdownUser";
// import LogoIcon from '../../images/logo/logo-icon.svg';
// import DarkModeSwitcher from "./DarkModeSwitcher";

const Header = props => {
    const dispatch = useDispatch()
    const { companyData, customersData } = useSelector(state => state.listData)
    const { company, customer } = useSelector(state => state.filterData)
    const user = useSelector(state => state.auth.user)

    // Populate companies dictionary when companyData changes
    useEffect(() => {
        if (companyData && companyData.length > 0) {
            dispatch(setCompaniesDict(companyData))
        }
    }, [companyData, dispatch])

    useEffect(() => {
        if (user?.company) {
            dispatch(setCompany(user?.company))
        }
        if (user?.customer) {
            dispatch(setCustomer(user?.customer))
        }
    }, [user, dispatch])

    return (
        <header className="sticky top-0 flex w-full bg-white z-999 drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
            <div className="flex items-center justify-between flex-grow px-2 py-2 shadow-3">
                <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
                    {/* <!-- Hamburger Toggle BTN --> */}
                    <button
                        aria-controls="sidebar"
                        onClick={e => {
                            e.stopPropagation()
                            props.setSidebarOpen(!props.sidebarOpen)
                        }}
                        className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
                    >
                        <span className="relative block h-5.5 w-5.5 cursor-pointer">
                            <span className="absolute right-0 w-full h-full du-block">
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!w-full delay-300'
                                    }`}
                                ></span>
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && 'delay-400 !w-full'
                                    }`}
                                ></span>
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!w-full delay-500'
                                    }`}
                                ></span>
                            </span>
                            <span className="absolute right-0 w-full h-full rotate-45">
                                <span
                                    className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!h-0 !delay-[0]'
                                    }`}
                                ></span>
                                <span
                                    className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!h-0 !delay-200'
                                    }`}
                                ></span>
                            </span>
                        </span>
                    </button>
                    {/* <!-- Hamburger Toggle BTN --> */}

                    <Link className="flex-shrink-0 block lg:hidden" to="/">
                        <img src="/images/logo.png" className="w-[50px]" alt="Logo" />
                    </Link>
                </div>

                {/* {user?.super_user && ( */}
                <div className="hidden w-full py-2 sm:flex items-center justify-end gap-2 sm:gap-4 lg:gap-6">
                    <Select
                        id="company"
                        name="company"
                        placeholder="Company"
                        className="md:min-w-54"
                        value={company}
                        options={companyData}
                        disabled={user?.company}
                        onChange={e => {
                            dispatch(setCompany(e.target.value))
                            dispatch(setCustomer(''))
                        }}
                    />
                    <Select
                        id="customer"
                        name="customer"
                        placeholder="Customer"
                        className="md:min-w-54"
                        value={customer}
                        disabled={user?.customer}
                        options={customersData.filter(item => item?.company?.id?.toString() === company?.toString())}
                        onChange={e => dispatch(setCustomer(e.target.value))}
                    />
                </div>
                {/* )} */}

                {/* <div className="flex items-center gap-3 xsm:gap-4">
                    <ul className="flex items-center gap-2 xsm:gap-4"> */}
                {/* <!-- Dark Mode Toggler --> */}
                {/* <DarkModeSwitcher /> */}
                {/* <!-- Dark Mode Toggler --> */}

                {/* <!-- Notification Menu Area --> */}
                {/* <DropdownNotification /> */}
                {/* <!-- Notification Menu Area --> */}

                {/* <!-- Chat Notification Area --> */}
                {/* <DropdownMessage /> */}
                {/* <!-- Chat Notification Area --> */}
                {/* </ul> */}

                {/* <!-- User Area --> */}
                {/* <DropdownUser /> */}
                {/* <!-- User Area --> */}
                {/* </div> */}
            </div>
        </header>
    )
}

export default Header
